import axios from "axios"
import {
    BANK_ACCOUNT_CHECKBOOK_ENDPOINT,
    BANK_ACCOUNT_CHECKBOOKS_ENDPOINT,
    BANK_ACCOUNTS_ENDPOINT,
    BANK_ACCOUNTS_ENDPOINT_ID,
    CHECKBOOKS_ENDPOINT,
    CHECKS_TO_CANCEL,
    UPDATE_BANK_ACCOUNTS_ENDPOINT
} from "../../../../../../utility/SourceAPI"

/**
 * Única capa que habla con el backend de cuentas bancarias.
 * Devuelve siempre `response.data`, nunca el envoltorio de axios, y deja que el
 * error suba tal cual: quien decide qué hacer con él es el thunk (rejectWithValue).
 */

export const fetchBankAccounts = async () => {
    const response = await axios.get(BANK_ACCOUNTS_ENDPOINT)
    return response.data
}

export const fetchBankAccountsMXN = async () => {
    const response = await axios.get(BANK_ACCOUNTS_ENDPOINT, { params: { currency: 'MXN', department: 'Bancos-Toluca' } })
    return response.data
}

export const fetchBankAccountsMXNKuspit = async () => {
    const response = await axios.get(BANK_ACCOUNTS_ENDPOINT, { params: { currency: 'MXN', department: 'Bancos-Kuspit' } })
    return response.data
}

export const fetchBankAccountsUSD = async () => {
    const response = await axios.get(BANK_ACCOUNTS_ENDPOINT, { params: { currency: 'USD' } })
    return response.data
}

export const fetchBankAccountById = async (bankAccountId) => {
    const response = await axios.get(BANK_ACCOUNTS_ENDPOINT_ID.concat(bankAccountId))
    return response.data
}

export const fetchBankAccountCheckbooks = async () => {
    const response = await axios.get(BANK_ACCOUNT_CHECKBOOKS_ENDPOINT)
    return response.data
}

export const fetchBankAccountCheckBooks = async () => {
    const response = await axios.get(BANK_ACCOUNT_CHECKBOOK_ENDPOINT)
    return response.data
}

export const createBankAccount = async (bankAccount) => {
    const response = await axios.post(BANK_ACCOUNTS_ENDPOINT, bankAccount)
    return response.data
}

export const updateBankAccount = async (bankAccountId, bankAccountData) => {
    const response = await axios.put(UPDATE_BANK_ACCOUNTS_ENDPOINT.concat(bankAccountId), bankAccountData)
    return response.data
}

export const updateManagerBankAccount = async (bankAccountId, bankAccount) => {
    const response = await axios.put(BANK_ACCOUNTS_ENDPOINT.concat(`assing_manager/${bankAccountId}/`), bankAccount)
    return response.data
}

export const hideBankAccount = async (bankAccountId) => {
    const response = await axios.put(BANK_ACCOUNTS_ENDPOINT.concat(`is_visible/${bankAccountId}/`), undefined, { params: { is_visible: false } })
    return response.data
}

export const createInvestment = async (bankAccount) => {
    const response = await axios.post(BANK_ACCOUNTS_ENDPOINT.concat('account_investment'), bankAccount)
    return response.data
}

//Cheques de la cuenta que se muestran antes de confirmar su cancelación
export const fetchChecksToCancel = async (bankAccountId) => {
    const response = await axios.get(`${CHECKS_TO_CANCEL}${bankAccountId}`)
    return response.data
}

//Chequeras de la cuenta que se muestran antes de confirmar su cancelación
export const fetchCheckbooksByAccount = async (bankAccountId) => {
    const response = await axios.get(`${CHECKBOOKS_ENDPOINT}?bank_account=${bankAccountId}`)
    return response.data
}
